// Only endpoints explicitly declaring readOnly may share an in-flight request.
// No completed business response is retained here.
export function createReadPool() {
  let scope = null
  let pending = new Map()
  const stable = value => {
    if (value instanceof URLSearchParams) { const copy = new URLSearchParams(value); copy.sort(); return copy.toString() }
    if (Array.isArray(value)) return value.map(stable)
    if (!value || typeof value !== 'object') return value
    return Object.keys(value).sort().reduce((out, key) => { if (value[key] !== undefined) out[key] = stable(value[key]); return out }, {})
  }
  const copy = response => {
    if (!response || !response.data || typeof response.data !== 'object' || response.data instanceof Blob || response.data instanceof ArrayBuffer) return response
    return { ...response, data: JSON.parse(JSON.stringify(response.data)) }
  }
  return (config, identity, send) => {
    if (scope !== identity) { scope = identity; pending = new Map() }
    if (!config.readOnly) {
      pending = new Map()
      return send(config).finally(() => { pending = new Map() })
    }
    const key = JSON.stringify([config.method, config.url, stable(config.params), stable(config.data), config.responseType, config.timeout])
    const entries = pending
    if (!entries.has(key)) {
      const promise = send(config).finally(() => { if (entries.get(key) === promise) entries.delete(key) })
      entries.set(key, promise)
    }
    return entries.get(key).then(copy)
  }
}
